export enum LinkLayoutOptionEnum{
    vertical,
    horizontal
}
